var map = {
	"./Approved.png": 804,
	"./Bonus-w.png": 805,
	"./E-Wallet-w.png": 806,
	"./IFERN-LOGO.jpg": 807,
	"./Paid-w.png": 808,
	"./Pending-w.png": 809,
	"./Rejected.png": 810,
	"./Untitled.jpeg": 811,
	"./available_income.png": 812,
	"./calendar.png": 503,
	"./danger.png": 813,
	"./image1.jpg": 814,
	"./image2.jpg": 815,
	"./income-w.png": 816,
	"./logo-dark.png": 221,
	"./logo-dark1.png": 817,
	"./logo_default.png": 818,
	"./logo_icon.png": 819,
	"./logo_login.png": 820,
	"./paid.png": 821,
	"./pending.png": 822,
	"./premium.png": 823,
	"./presidential.png": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;